module.exports = __webpack_public_path__ + "img/b-icon_clientarea-login(1).7ce17bf6.svg";